import React from "../_snowpack/pkg/react.js";
import PrintTemplatesPage from "../components/print-templates-page.js";
import App from "../components/app.js";
export default function PrintTemplates(props) {
  const {page} = props;
  return /* @__PURE__ */ React.createElement(App, {
    ...props
  }, /* @__PURE__ */ React.createElement(PrintTemplatesPage, {
    ...props
  }));
}
